module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box box-body"
  }, [(_vm.purchaseHeaderObj.reportType == 'Invoice') ? _c('div', {
    staticClass: "col-sm-3",
    attrs: {
      "id": "billNo"
    }
  }, [_c('label', {
    attrs: {
      "for": "billNo"
    }
  }, [_vm._v("Bill No :")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput "
  }, [_c('b', [_vm._v(_vm._s(_vm.purchaseHeaderObj.billNo))])])]) : _vm._e(), _vm._v(" "), (_vm.purchaseHeaderObj.reportType == 'Challan') ? _c('div', {
    staticClass: "col-sm-3",
    attrs: {
      "id": "challanNo"
    }
  }, [_c('label', {
    attrs: {
      "for": "challanNo"
    }
  }, [_vm._v("Challan No :")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput "
  }, [_c('b', [_vm._v(_vm._s(_vm.purchaseHeaderObj.challanNo))])])]) : _vm._e(), _vm._v(" "), (_vm.purchaseHeaderObj.reportType == 'Order') ? _c('div', {
    staticClass: "col-sm-3",
    attrs: {
      "id": "orderNo"
    }
  }, [_c('label', {
    attrs: {
      "for": "orderNo"
    }
  }, [_vm._v("Order No :")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput "
  }, [_c('b', [_vm._v(_vm._s(_vm.purchaseHeaderObj.orderNo))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 ",
    staticStyle: {
      "margin-left": "-12%"
    },
    attrs: {
      "id": "referenceNumber"
    }
  }, [_c('label', {
    attrs: {
      "for": "referenceNumber"
    }
  }, [_vm._v("Reference No. :")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput "
  }, [_c('b', [_vm._v(_vm._s(_vm.purchaseHeaderObj.referenceNumber) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    staticStyle: {
      "margin-left": "-8%"
    },
    attrs: {
      "id": "purchaseDate"
    }
  }, [_c('label', {
    attrs: {
      "for": "purchaseDate"
    }
  }, [_vm._v(" Date :")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput"
  }, [_c('b', [_vm._v(_vm._s(_vm.purchaseHeaderObj.purchaseDate))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 ",
    staticStyle: {
      "margin-left": "-5%"
    },
    attrs: {
      "id": "warehouseName"
    }
  }, [_c('label', {
    attrs: {
      "for": "WarehouseName"
    }
  }, [_vm._v("Store :")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput "
  }, [_c('b', [_vm._v(_vm._s(_vm.purchaseHeaderObj.warehouse.name) + " ")])])]), _vm._v(" "), (_vm.purchaseHeaderObj.reportType == 'Invoice') ? _c('div', {
    staticClass: "col-sm-3 ",
    staticStyle: {
      "margin-left": "-1%"
    },
    attrs: {
      "id": "warehouseName"
    }
  }, [_c('label', {
    attrs: {
      "for": "WarehouseName"
    }
  }, [_vm._v("Bill Type :")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput "
  }, [_c('b', [_vm._v(_vm._s(_vm.purchaseHeaderObj.vatTypeEnum) + " ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    attrs: {
      "id": "suppplier"
    }
  }, [_c('label', {
    attrs: {
      "for": "suppplier"
    }
  }, [_vm._v("Customer :")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput "
  }, [_c('b', [_vm._v(_vm._s(_vm.purchaseHeaderObj.account.name))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.purchaseHeaderObj.account.name == 'Cash'),
      expression: "purchaseHeaderObj.account.name=='Cash'"
    }],
    staticClass: "col-sm-3",
    attrs: {
      "id": "suppplier"
    }
  }, [_c('label', {
    attrs: {
      "for": "suppplier"
    }
  }, [_vm._v("Bill From :")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput "
  }, [_c('b', [_vm._v(_vm._s(_vm.purchaseHeaderObj.account.billToName))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.purchaseHeaderObj.account.name != 'Cash'),
      expression: "purchaseHeaderObj.account.name !='Cash'"
    }],
    staticClass: "col-sm-3",
    attrs: {
      "id": "suppplier"
    }
  }, [_c('label', {
    attrs: {
      "for": "suppplier"
    }
  }, [_vm._v("Address :")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput "
  }, [_c('b', [_vm._v(_vm._s(_vm.purchaseHeaderObj.account.address))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.purchaseHeaderObj.account.name != 'Cash'),
      expression: "purchaseHeaderObj.account.name !='Cash'"
    }],
    staticClass: "col-sm-3",
    attrs: {
      "id": "suppplier"
    }
  }, [_c('label', {
    attrs: {
      "for": "suppplier"
    }
  }, [_vm._v("Vat/Pan No :")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput "
  }, [_c('b', [_vm._v(_vm._s(_vm.purchaseHeaderObj.account.panNo))])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered ",
    staticStyle: {
      "margin-top": "5%"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.inventoryInOutDetailList), function(pd, index) {
    return _c('tbody', {
      key: index
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pd.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pd.quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pd.fatPercentage))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pd.fatAmount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pd.snfPercentage))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pd.snfAmount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pd.tsPercentage))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pd.tsAmount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pd.rateAdjustment))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pd.rate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s((pd.quantity * pd.rate).toFixed(4)) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "p-field p-col-12 p-md-2"
    }, [_c('Button', {
      staticClass: "p-button-raised",
      attrs: {
        "icon": "pi pi-eye"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.posDetail(pd)
        }
      }
    })], 1)])])
  })], 2), _vm._v(" "), (this.extraExpensesList.length > 0) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('h5', [_vm._v("Extra Expenses")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered ",
    staticStyle: {
      "margin-top": "2%"
    }
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.extraExpensesList), function(expenses, index) {
    return _c('tbody', {
      key: index
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expenses.expensesName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expenses.extraExpenseAmt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expenses.applyVat))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expenses.debitAccountName) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expenses.creditAccountName))])])])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', [_vm._v("Narration")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.purchaseHeaderObj.remarks),
      expression: "purchaseHeaderObj.remarks"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "rows": "6"
    },
    domProps: {
      "value": (_vm.purchaseHeaderObj.remarks)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.purchaseHeaderObj, "remarks", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.purchaseHeaderObj.reportType == 'Invoice') ? _c('div', {
    staticClass: "col-xs-4 _total",
    staticStyle: {
      "float": "right",
      "margin-right": "-18%",
      "margin-top": "3%"
    }
  }, [_c('label', {
    attrs: {
      "for": "subttotal"
    }
  }, [_vm._v("Subtotal: ")]), _vm._v(" "), _c('span', {
    staticClass: "_span",
    staticStyle: {
      "margin-left": "10%"
    },
    attrs: {
      "id": "subttotal"
    }
  }, [_vm._v(_vm._s((_vm.purchaseHeaderObj.subTotalAmount).toFixed(4)) + " ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    attrs: {
      "for": "discountamt"
    }
  }, [_vm._v("Discount Amt: ")]), _vm._v(" "), _c('span', {
    staticClass: "_span",
    staticStyle: {
      "margin-left": "3%"
    },
    attrs: {
      "id": "discountamt"
    }
  }, [_vm._v(_vm._s(_vm.purchaseHeaderObj.discountAmt) + " ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    attrs: {
      "for": "exciseDuty"
    }
  }, [_vm._v("Excise Charge: ")]), _vm._v(" "), _c('span', {
    staticClass: "_span",
    staticStyle: {
      "margin-left": "3%"
    },
    attrs: {
      "id": "exciseDuty"
    }
  }, [_vm._v(_vm._s(_vm.purchaseHeaderObj.exciseChargeAmount) + " ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    attrs: {
      "for": "nontaxable"
    }
  }, [_vm._v("Non-taxable:")]), _vm._v(" "), _c('span', {
    staticClass: "_span",
    staticStyle: {
      "margin-left": "5%"
    },
    attrs: {
      "id": "nontaxable"
    }
  }, [_vm._v(_vm._s((_vm.purchaseHeaderObj.nonTaxableAmount).toFixed(4)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    attrs: {
      "for": "taxable"
    }
  }, [_vm._v("Taxable:")]), _vm._v(" "), _c('span', {
    staticClass: "_span",
    staticStyle: {
      "margin-left": "11%"
    },
    attrs: {
      "id": "taxable"
    }
  }, [_vm._v(_vm._s((_vm.purchaseHeaderObj.taxableAmount).toFixed(4)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    attrs: {
      "for": "tax"
    }
  }, [_vm._v("Tax(13%):")]), _vm._v(" "), _c('span', {
    staticClass: "_span",
    staticStyle: {
      "margin-left": "9%"
    },
    attrs: {
      "id": "tax"
    }
  }, [_vm._v(_vm._s((_vm.purchaseHeaderObj.vatAmount).toFixed(4)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    attrs: {
      "for": "total"
    }
  }, [_vm._v("Total:")]), _vm._v(" "), _c('span', {
    staticClass: "_span",
    staticStyle: {
      "margin-left": "15%"
    },
    attrs: {
      "id": "total"
    }
  }, [_vm._v(_vm._s((_vm.purchaseHeaderObj.totalBillAmount).toFixed(4)))]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-footer",
    staticStyle: {
      "margin-top": "12%"
    }
  }, [_c('Button', {
    staticClass: "p-button-raised",
    staticStyle: {
      "margin-top": "10px",
      "float": "right",
      "margin-left": "100%"
    },
    attrs: {
      "icon": "pi pi-refresh",
      "label": "Back"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.back()
      }
    }
  })], 1)]), _vm._v(" "), _c('Dialog', {
    style: ({
      width: '50vw'
    }),
    attrs: {
      "header": "Purchase Batch Details",
      "modal": true,
      "visible": _vm.showPosDialog,
      "closable": false,
      "contentStyle": {
        'overflow': 'visible'
      }
    },
    on: {
      "update:visible": function($event) {
        _vm.showPosDialog = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('Button', {
          staticClass: "p-button-raised p-button-rounded",
          attrs: {
            "label": "Back"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.cancel.apply(null, arguments)
            }
          }
        })]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Batch Name: "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(this.batch))])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "shortName"
    }
  }, [_vm._v("Bonus: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(this.bonus))])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "manufactureDate"
    }
  }, [_vm._v("Manufacture Date: \"")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(this.manufactureDate))])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "expiryDate"
    }
  }, [_vm._v("Expiry Date: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(this.expiryDate))])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "shortName"
    }
  }, [_vm._v("Free Qty: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(this.freeQty))])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "ccPercentage"
    }
  }, [_vm._v("Cc Percentage: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(this.ccPercentage))])])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("SN")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Item Name")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Quantity")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Fat%")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Fat Amount")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Snf%")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Snf Amount")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Ts%")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Ts Amount")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Extra")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Rate")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Amount")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("SN")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Vatable")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Debit Account")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Credit Account")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2694e802"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/salesReport/salesDetailsDairyReport.vue
// module id = 2099
// module chunks = 0